export default __webpack_public_path__ + "static/spectrum-logo-black-182b7cc4adeced5da17cc25a824b3284.png";